export class AdminOverview {
  totalUsers: number

  totalCompanies: number

  totalTestOrDemoCompanies: number

  totalMetricEligibleCompanies: number

  totalCouriers: number

  totalOrders: number

  totalManualExternalOrders: number

  totalDeliveries: number

  constructor(data: Partial<AdminOverview> = {}) {
    this.totalUsers = data.totalUsers ?? 0

    this.totalCompanies = data.totalCompanies ?? 0

    this.totalTestOrDemoCompanies = data.totalTestOrDemoCompanies ?? 0

    this.totalMetricEligibleCompanies = data.totalMetricEligibleCompanies ?? 0

    this.totalCouriers = data.totalCouriers ?? 0

    this.totalOrders = data.totalOrders ?? 0

    this.totalManualExternalOrders = data.totalManualExternalOrders ?? 0

    this.totalDeliveries = data.totalDeliveries ?? 0
  }
}
